module.exports = __webpack_public_path__ + "static/img/4A.25548421.svg";